import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../Api_Module';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {

    constructor(private usersService: UsersService, private toastr: ToastrService) { }
    username: string;
    loading: boolean;
    success: boolean;
  ngOnInit() {
  }

    reset() {
        this.loading = true;
        this.usersService.resetUser(this.username).subscribe(resp => {
            this.loading = false;
            this.toastr.info('An email has been sent with reset instructions,please check your inbox !!!');
        },
            
            error => {
                this.toastr.info('An email has been sent with reset instructions,please check your inbox  !!!');
                //this.toastr.error('Login Failed!');
                this.loading = false;
            });
        

}

}
